<div class="permission-text">
  <h4 class="section-hdr daily-export">
    {{ 'shared.dailyExportLimitsForDifferentEntities' | translate | titlecase }}
  </h4>
</div>
<div class="export-limits-table-wrapper">
<table aria-hidden="true" cdk-table [dataSource]="exportLimitsDataSource" class="exportslimit">
  <ng-container cdkColumnDef="availability">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef>
      {{ 'shared.availability' | translate | titlecase }}
    </th>
    <td cdk-cell *cdkCellDef="let exportLimit">{{ exportLimit.availability }}</td>
  </ng-container>
  <ng-container cdkColumnDef="lease">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef>
      {{ 'shared.leaseComps' | translate | titlecase }}
    </th>
    <td cdk-cell *cdkCellDef="let exportLimit">{{ exportLimit.lease }}</td>
  </ng-container>
  <ng-container cdkColumnDef="sale">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef>
      {{ 'shared.saleComps' | translate | titlecase }}
    </th>
    <td cdk-cell *cdkCellDef="let exportLimit">{{ exportLimit.sale }}</td>
  </ng-container>
  <ng-container cdkColumnDef="portfoliosale">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef>
      {{ 'shared.portfoliosaleComps' | translate | titlecase }}
    </th>
    <td cdk-cell *cdkCellDef="let exportLimit">{{ exportLimit.portfoliosale }}</td>
  </ng-container>
  <ng-container cdkColumnDef="property">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef>
      {{ 'shared.property' | translate | titlecase }}
    </th>
    <td cdk-cell *cdkCellDef="let exportLimit">{{ exportLimit.property }}</td>
  </ng-container>
  <ng-container cdkColumnDef="tim">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef>{{ 'shared.tim' | translate }}</th>
    <td cdk-cell *cdkCellDef="let exportLimit">{{ exportLimit.tim }}</td>
  </ng-container>
  <ng-container cdkColumnDef="company">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef>{{ 'shared.company' | translate | titlecase }}</th>
    <td cdk-cell *cdkCellDef="let exportLimit">{{ exportLimit.company }}</td>
  </ng-container>
  <ng-container cdkColumnDef="contact">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef>{{ 'shared.contact' | translate | titlecase }}</th>
    <td cdk-cell *cdkCellDef="let exportLimit">{{ exportLimit.contact }}</td>
  </ng-container>
  <ng-container cdkColumnDef="tenancy">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef>{{ 'shared.tenancy' | translate | titlecase }}</th>
    <td cdk-cell *cdkCellDef="let exportLimit">{{ exportLimit.tenancy }}</td>
  </ng-container>
  <ng-container cdkColumnDef="brand">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef>{{ 'shared.brand' | translate | titlecase }}</th>
    <td cdk-cell *cdkCellDef="let exportLimit">{{ exportLimit.brand }}</td>
  </ng-container>
  <ng-container cdkColumnDef="space">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef>{{ 'shared.space' | translate | titlecase }}</th>
    <td cdk-cell *cdkCellDef="let exportLimit">{{ exportLimit.space }}</td>
  </ng-container>
  <ng-container cdkColumnDef="activity">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef>{{ 'shared.activity' | translate | titlecase }}</th>
    <td cdk-cell *cdkCellDef="let exportLimit">{{ exportLimit.activity }}</td>
  </ng-container>
  <ng-container cdkColumnDef="actions">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef></th>
    <td cdk-cell *cdkCellDef="let exportLimit">
      @if (!isReadyOnly()) {
        <button mat-icon-button class="submit-btn" (click)="openEditDialog()">
          <mat-icon [matTooltip]="'tooltip.edit' | translate" class="edit-mode">edit</mat-icon>
        </button>
      }
    </td>
  </ng-container>
  <tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
  <tr cdk-row *cdkRowDef="let row; columns: displayedColumns"></tr>
</table>
</div>
